<!-- Step: INITIAL -->
<div id="step-initial" class="flex min-h-full flex-1 flex-col">
  <div class="flex justify-center mt-fdk-xxl">
    <fdk-illustration name="welcome-animated" />
  </div>

  <div class="text-center mt-fdk-l">
    <h2 class="fdk-type-heading-2 text-fdk-primary">
      {{ (configService.systemConfigSubject | async)?.companyName || (configService.systemConfigSubject | async)?.org?.name || "Unknown" }} uses Fasten to bring your health records together in one place
    </h2>
  </div>

  <div class="mt-fdk-m">
    <div>
      <h3 class="fdk-type-heading-4 text-fdk-primary">Safe</h3>
      <p class="fdk-type-paragraph text-fdk-secondary mt-fdk-xxxs">
        Your records are encrypted end-to-end, the same standard used in online banking.
      </p>
    </div>

    <div class="mt-fdk-m">
      <h3 class="fdk-type-heading-4 text-fdk-primary">Private</h3>
      <p class="fdk-type-paragraph text-fdk-secondary mt-fdk-xxxs">
        We never sell your data. It's only shared with the providers you choose.
      </p>
    </div>
  </div>

  <div class="mt-auto pt-6 space-y-6">
    <p class="fdk-type-paragraph-s text-fdk-secondary">
      By clicking continue you agree to: Fasten's
      <fdk-link
        href="https://policy.fastenhealth.com/connect/privacy_policy.html"
        target="_blank"
      >Privacy Policy</fdk-link>
      and
      <fdk-link
        href="https://policy.fastenhealth.com/terms.html"
        target="_blank"
      >Terms & Conditions</fdk-link>
      {{ (configService.systemConfigSubject | async)?.companyName || (configService.systemConfigSubject | async)?.org?.name || "Unknown" }}'s
      <fdk-link
        [href]="(configService.systemConfigSubject | async)?.org?.privacy_policy_uri ?? ''"
        target="_blank"
      >Privacy Policy</fdk-link>
    </p>

    <fdk-button
      type="button"
      variant="primary"
      width="full"
      [routerLink]="'/search'"
    >
      Connect my health records
    </fdk-button>
  </div>
</div>
<!-- End Step: INITIAL -->
